import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
render(<AppRouter data-id="element-2201" />, document.getElementById('root'));